import FieldFile from "@local/components/field-file";
import FieldGroup from "@local/components/field-group";
import FieldSelect from "@local/components/field-select";
import Modal from "@local/components/modal";
import { reduxForm, Field } from "redux-form";
import { isRequired, isValidDate } from "@local/utils/validators";
import FieldText from "@local/components/field-text";
import FieldDatePicker from "@local/components/field-date-picker";
import Button from "@local/components/button";
import ConfirmModal from "@local/components/confirm-modal";
import { useState } from "react";
import { connect } from "react-redux";
import FieldSingleSelectSearch from "@local/components/field-single-search-select";
import i18n from "@local/i18next/i18n";
const AddAssessmentModal = ({ isOpen, onClose, formValues, onAsseessmentSubmit, countries, invalid }) => {
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        title={i18n.t("Add Assessment Report")}
        footer={
          <>
            <Button text={"Cancel"} onClick={onClose} />
            <Button isDisabled={invalid} text={"Submit"} onClick={() => setIsConfirmOpen(true)} />
          </>
        }
      >
        <FieldGroup>
          <Field component={FieldText} validate={[isRequired]} id="report_name" name="report_name" label={i18n.t("Report Name")} placeholder={i18n.t("Report Name")} />
          <Field component={FieldSingleSelectSearch} validate={[isRequired]} id="operating_country" name="operating_country" label={i18n.t("Operation Country")} placeholder={i18n.t("Operation Country")} valueField="value" labelField="label" options={countries} />
          <Field component={FieldText} validate={[isRequired]} id="assessment_type" name="assessment_type" label={i18n.t("Type of Assessment")} placeholder={i18n.t("Type of Assessment")} />
          <Field
            component={FieldSelect}
            validate={[isRequired]}
            id="risk_level"
            name="risk_level"
            label={i18n.t("Evaluated Risk")}
            placeholder={i18n.t("Evaluated Risk")}
            valueField="value"
            labelField="label"
            options={[
              { label: "High", value: "high" },
              { label: "Significant", value: "significant" },
              { label: "Moderate", value: "moderate" },
              { label: "Low", value: "low" },
              { label: "Not Applicable", value: "not_applicable" },
            ]}
          />
          <Field component={FieldDatePicker} validate={[isRequired, isValidDate]} maximumDate={new Date()} id="assessment_date" name="assessment_date" label={i18n.t("Assessment Date")} placeholder={i18n.t("Assessment Date")} />
          <Field component={FieldDatePicker} minimumDate={new Date(formValues?.["assessment_date"])} validate={[isRequired, isValidDate]} id="valid_until" name="valid_until" label={i18n.t("Valid Until")} placeholder={i18n.t("Valid Until")} />
          <Field validate={[isRequired]} multiple={true} component={FieldFile} id="attachments" name="attachments" label={i18n.t("Attachments")} placeholder={i18n.t("Attachments")} readOnly={false} />
        </FieldGroup>
      </Modal>
      <ConfirmModal
        isOpen={isConfirmOpen}
        onSubmit={async () => {
          await onAsseessmentSubmit(formValues);
          setIsConfirmOpen(false);
        }}
        onClose={() => setIsConfirmOpen(false)}
        title={i18n.t("Add Assessment")}
        message={i18n.t("Do you confirm adding this assessment?")}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  formValues: state.form?.addAssessmentModalForm?.values,
});

export default connect(mapStateToProps)(reduxForm({ form: "addAssessmentModalForm", enableReinitialize: true })(AddAssessmentModal));
